export default {
  methods: {

    draw_Form() {

      this.formCanvas = this.svg
      .append('g')
      .attr('transform', `translate(-50, 30.5)`)
      .attr('font-family', 'roboto')

      this.formCanvas
      .append('text')
      .attr('x', -5).attr('y', -20)
      .attr('font-size', 25).attr('fill', '#000')
      .text('Component Status for Use')

      let types = [ ...new Set(this.dataSet.map(d => d.type)) ]

      let x_ = 0
      types.forEach(d=> {
        this.formCanvas
        .append('text')
        .attr('x', x_).attr('y', 13)
        .attr('font-size', 14).attr('fill', '#000')
        .attr('text-anchor', 'start')
        .attr('opacity',1)
        .text(d.toUpperCase())
        x_ = x_ + 210
      })

      let y_ = 30
      x_ = 0
      this.dataSet.forEach((d, i) => {
        
        let tbl = this.formCanvas
        .append('g')
        .attr('cursor', 'pointer')
        .call(this.call_Link, d)

        let opacity = 0
        if(d.count > 0 && d.count < 11) opacity = .25
        if(d.count > 10 && d.count < 31) opacity = .5
        if(d.count > 30 && d.count < 51) opacity = .75
        if(d.count > 50) opacity = 1
        tbl
        .append('rect')
        .attr('class',`BOX`)
        .attr('x', x_).attr('y', y_)
        .attr('width', 135).attr('height', 20)
        .attr('stroke', '#bcbcbc').attr('stroke-width', 1)
        .attr('fill', d.count == 0 ? 'none' : '#44A9DF')
        .attr('opacity', .3).attr('fill-opacity', opacity)

        tbl
        .append('rect')
        .attr('class',`BOX`)
        .attr('x', x_ + 145).attr('y', y_)
        .attr('width', 25).attr('height', 20)
        .attr('stroke', d.count == 0 ? '#bcbcbc' : '#757575').attr('stroke-width', 1)
        .attr('fill', d.count == 0 ? 'none' : '#44A9DF')
        .attr('opacity', .3).attr('fill-opacity', opacity)
   
        tbl
        .append('text')
        .attr('x', x_+5).attr('y', y_ + 14)
        .attr('font-size', 11).attr('fill', '#333')
        .attr('text-anchor', 'start')
        .attr('opacity',1)
        .text(d.name)

        tbl
        .append('text')
        .attr('x', x_+ 165).attr('y', y_ + 14)
        .attr('font-size', 11).attr('fill', '#333')
        .attr('text-anchor', 'end')
        .attr('opacity', d.count == 0 ? .3 : 1)
        .text(d.count)

        // console.log(d.type, this.dataSet[i+1])
        if(i == this.dataSet.length-1) return
        if(d.type != this.dataSet[i+1].type) {
          x_ = x_ + 210
          y_ = 30
        } else
        y_ = y_ + 40
        
      })

    },



  }
}